import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useContext } from "react";
import { ControlComponentContext } from "../ComponentContext/ControlComponentContext";
import { PluginHelper } from "../ReactPageLayout/helpers/PluginHelper";
import { ControlCellChildren } from "./ControlCellChildren";
import { ControlCellChildrenInline } from "./ControlCellChildrenInline";
import { ControlLayoutContext } from "./ControlLayoutContext";
import { LayoutControlType } from "./LayoutControlType";
const INLINE_CONTROLS = [
    LayoutControlType.Radios,
    LayoutControlType.Checkboxes,
    LayoutControlType.SingleCheckbox,
    LayoutControlType.Select,
];
export function ControlCell(props) {
    var _a;
    const { node } = props;
    // lookup component for rendering values
    const components = useContext(ControlComponentContext);
    const pluginId = PluginHelper.getPluginId(node);
    const componentProps = PluginHelper.getPluginProps(props.node);
    const Component = (_a = components[pluginId]) !== null && _a !== void 0 ? _a : ControlComponentFallback;
    // we need to know how to display the debug value
    const ChildrenComponent = INLINE_CONTROLS.includes(pluginId)
        ? ControlCellChildrenInline
        : ControlCellChildren;
    return (_jsx(ControlLayoutContext.Provider, { value: componentProps, children: _jsx(Component, Object.assign({}, componentProps, { children: _jsx(ChildrenComponent, { rows: node.rows }) })) }));
}
function ControlComponentFallback(props) {
    return _jsx(Fragment, { children: props.children });
}
//# sourceMappingURL=ControlCell.js.map